import React from 'react';
import PropTypes from 'prop-types';

import { Alert } from 'react-bootstrap';

export default function ActivityErrors({ errors }) {
  if (!errors?.length) {
    return null;
  }

  return (
    <Alert bsStyle="warning">
      {errors.map((error, i) => <div key={i}>{error}</div>)}
    </Alert>
  );
}

ActivityErrors.propTypes = {
  errors: PropTypes.arrayOf(PropTypes.string),
};
